var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ViewArchive } from '@isyc-react/archives/view';
import { ArchiveViewerProvider } from '@isyc-react/archives/view/viewer/context';
import { ViewerArchiveModal } from '@isyc-react/archives/view/viewer/modal';
import React from 'react';
export const ViewPublicArchiveModal = props => {
    const { archive, show, onChange } = props, rest = __rest(props, ["archive", "show", "onChange"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ArchiveViewerProvider, null,
            React.createElement(ViewerArchiveModal, { name: archive === null || archive === void 0 ? void 0 : archive.name, show: show, onChange: onChange }, archive && (React.createElement(ViewArchive, Object.assign({ archive: { base64: { mime: archive.format, data: archive.content } }, name: archive.name }, rest)))))));
};
